import { CLUSTER_KEYS } from '@/config/market-config'
import { HYPEREVM_PRODUCTS } from '@/features/evault-details/data/products'

/**
 * URL `?from=` parameter values used to restore navigation context after
 * visiting a vault detail page. Includes any registered cluster key plus
 * `'earn'` / `'isolated'` aliases used by other back-source producers.
 */
export type EarnBackSource = string

/**
 * Cluster key for an elend-backed product (e.g. `'prime'`, `'scale'`, `'moon'`).
 * Widened to `string` since cluster keys are now derived from `HYPEREVM_PRODUCTS`.
 */
export type ELendBackSource = string

/**
 * Given a vault's `market.key` (e.g. `hypurrfi-scale`), return the cluster-key
 * form used in URL `?from=` params (`'scale'`). Returns `undefined` for keys
 * that don't correspond to an elend-backed cluster — evault clusters (e.g. Earn)
 * and unknown products are excluded.
 *
 * Fully data-driven: a new elend cluster added to `HYPEREVM_PRODUCTS` is
 * recognized here automatically.
 */
export function getELendBackSource(marketKey: string | null | undefined): ELendBackSource | undefined {
  if (!marketKey) return undefined
  const clusterKey = marketKey.toLowerCase().replace(/^hypurrfi-/, '')
  if (!CLUSTER_KEYS.includes(clusterKey)) return undefined
  const product = HYPEREVM_PRODUCTS.get(`hypurrfi-${clusterKey}`)
  return product?.source === 'elend' ? clusterKey : undefined
}
